import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
})
export class DateInputComponent implements OnInit {

  dayValue;
  monthValue;
  yearValue;

  days = [
    { id: '01' },
    { id: '02' },
    { id: '03' },
    { id: '04' },
    { id: '05' },
    { id: '06' },
    { id: '07' },
    { id: '08' },
    { id: '09' },
    { id: '10' },
    { id: '11' },
    { id: '12' },
    { id: '13' },
    { id: '14' },
    { id: '15' },
    { id: '16' },
    { id: '17' },
    { id: '18' },
    { id: '19' },
    { id: '20' },
    { id: '21' },
    { id: '22' },
    { id: '23' },
    { id: '24' },
    { id: '25' },
    { id: '26' },
    { id: '27' },
    { id: '28' },
    { id: '29' },
    { id: '30' },
    { id: '31' },
  ];

  months = [
    { id: '01', name: 'January' },
    { id: '02', name: 'February' },
    { id: '03', name: 'March' },
    { id: '04', name: 'April' },
    { id: '05', name: 'May' },
    { id: '06', name: 'June' },
    { id: '07', name: 'July' },
    { id: '08', name: 'August' },
    { id: '09', name: 'September' },
    { id: '10', name: 'Octuber' },
    { id: '11', name: 'November' },
    { id: '12', name: 'December' },
  ];
  years = [];

  @Input() birthDate = '';
  @Output() birthDateSelected = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this.createYearArray();
    if (this.birthDate) {
      const birthArray = this.birthDate.split('/');
      this.dayValue = birthArray[0];
      this.monthValue = birthArray[1];
      this.yearValue = birthArray[2];
    }
  }

  createYearArray() {
    const max = new Date().getFullYear() - 16;
    const min = max - 100;

    for (let i = max; i >= min; i--) {
      this.years.push(i.toString());
    }
  }

  handleChange(event) {
    if (this.dayValue && this.monthValue && this.yearValue) {
      this.birthDateSelected.emit(this.yearValue + '/' + this.monthValue + '/' + this.dayValue);
    }
  }

}
